// @ts-nocheck - Legacy file with type issues requiring refactoring (TODO: GXM-XXXX)
import { Card } from "primereact/card";
import CustomeButton from "~/components/Button";
import AdminOnly from "~/components/AdminOnly";
import useOfficersAndAttornyRegistry from "../Officers/useOfficersAttornyRegistry";
import OfficersAndPowerOfAttornyTable from "../Officers/components/OfficersAndPowerOfAttornyTable";
const OfficersAttornyRegistryTab = ({ type }) => {
  const {
    search,
    setSearchQuery,
    data,
    loading,
    isDataAvailable,
    totalRecord,
    onPageChange,
    rows,
    page,
    isUserRegestered,
    sortMeta,
    onSort,
    handleNavigate,
  } = useOfficersAndAttornyRegistry({ type });
  return (
    <>
      <div className="flex mb-5">
        <div className="input-wrapper-container width__full flex-1">
          <span className="pi pi-search"></span>
          <input
            type="text"
            placeholder={
              type === "officer"
                ? "Search Officers by given name, surname or role"
                : "Search Power of Attorney by given name, surname or role"
            }
            className="appearance-none outline-none w-full"
            value={search}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
        <AdminOnly>
          <CustomeButton
            label={type === "officer" ? "Add Officer" : "Add Attorney"}
            variant="contained"
            className="access-btn"
            icon="pi pi-plus"
            iconPos="right"
            onClick={handleNavigate}
          />
        </AdminOnly>
      </div>
      <Card className="gen-card">
        <OfficersAndPowerOfAttornyTable
          search={search}
          data={data}
          loading={loading}
          isDataAvailable={isDataAvailable}
          totalRecords={totalRecord}
          onPageChange={onPageChange}
          type={type}
          isUserRegestered={isUserRegestered}
          rows={rows}
          page={page}
          sortMeta={sortMeta}
          onSort={onSort}
          handleNavigate={handleNavigate}
        />
      </Card>
    </>
  );
};

export default OfficersAttornyRegistryTab;
